// Scope 2 v2 constants. Codes MUST match the backend enums
// (PurchasedElectricityCategory; certificate/fuel types are free-text columns).
// Display labels/descriptions live in i18n under `organizationQuestionnaire.scope2V2.*`.

export const PURCHASED_CATEGORIES = [
  "STANDARD_GRID",
  "SUPPLIER_CONTRACTED",
  "CERTIFIED_RENEWABLE",
  "DIRECT_PRIVATE_WIRE",
];

// Categories whose per-row emission factor is mandatory before calculation.
export const FACTOR_REQUIRED_CATEGORIES = ["SUPPLIER_CONTRACTED", "DIRECT_PRIVATE_WIRE"];

export const isFactorRequiredCategory = (category) =>
  FACTOR_REQUIRED_CATEGORIES.includes(category);

// Renewable certificate / contract instruments — only relevant when the row's
// category is CERTIFIED_RENEWABLE.
export const RENEWABLE_TYPES = ["GO", "REGO", "REC", "IREC", "PPA", "GREEN_TARIFF"];

// On-site generation fuel / technology types.
export const ONSITE_FUEL_TYPES = [
  "SOLAR_PV",
  "WIND",
  "HYDRO",
  "BIOMASS",
  "GEOTHERMAL",
  "BATTERY_STORAGE",
  "OTHER",
];

// Certificate types for the on-site section (active when certificatesIssued).
export const ONSITE_CERTIFICATE_TYPES = ["REGO", "GO", "IREC", "REC", "NONE"];

// kWh is the only measure for Scope 2 v2 electricity.
export const KWH_MEASURE_CODE = "KWH";
